<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "UserView"
}
</script>

<style scoped>

</style>